module.exports = __webpack_public_path__ + "mobile_app_loanchat_qr_code_android.eccbb8d.png";